import React, { useState, useEffect } from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import Select from '../../../dpe-usco/components/Select/Select'

const AvailableContractTypesWidget = ({
  returnData,
  contractTypes,
  initialType
}) => {
  const [contractType, setContractType] = useState()

  const onSubmit = e => {
    e.preventDefault()
  }

  const handleSelectContract = type => {
    setContractType(type)
    returnData({
      type: 'UPDATE_SELECTED_CONTRACT_TYPE',
      payload: { contract_type_id: type.id, contract_type_enum: type.value }
    })
  }

  useEffect(() => {
    if (!contractType && initialType) {
      setContractType(initialType)
    }
  }, [contractType, initialType])

  return (
    <Widget title="Available contract types">
      <form onSubmit={onSubmit}>
        <div className="mb20 w45%">
          <label className="df mb10" htmlFor="contractType">
            Contract type*
          </label>
          <Select
            defaultId={contractType ? contractType.id : null}
            placeholder="Select contract type"
            handleSelection={handleSelectContract}
            options={contractTypes}
            name="contractType"
            aria-label="contractType"
          />
        </div>
      </form>
    </Widget>
  )
}

export default AvailableContractTypesWidget
